module.exports = __webpack_public_path__ + "img/length_2.79b315e2.png";